import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { legal } from "../i18n/legal";
import { LegalPage } from "../components/legal/LegalPage";
export function DataDeletion() {
  const {
    lang
  } = useLanguage();
  return <LegalPage content={legal[lang].deletion} showWhatsapp data-id="element-295" data-mp="2382pbsly451y" />;
}